import { Form } from 'factorial-form'

class LegalEntitySelectForm extends Form {
  constructor(values: object) {
    super(values, {
      legal_entity_id: 'number',
      employee_group_id: 'number',
    })
  }
}

export default LegalEntitySelectForm
